import {
  AppContextProvider,
  useCart,
  useDealer,
  useSettings
} from "@/contexts";
import { useEffect, useState } from "react";
import { ProductCatalog, HomePageHeader } from "../../organisms";
import * as S from "./styles";
import Cart from "../Cart";
import SavedOrderDialog from "../../molecules/SavedOrderDialog";
import axios from "axios";

const Home: React.FC = () => {
  const { cart, setCart } = useCart();
  const { settings } = useSettings();
  const { dealer, coopInfo } = useDealer();
  const [isSavedOrderDialogOpen, setIsSavedOrderDialogOpen] = useState(false);
  const [savedOrder, setSavedOrder] = useState<any>(null);
  console.log('Settings:', settings, " dealer:", dealer);
  // useEffect(() => {
  //   const checkSavedOrder = async () => {
  //     if (!dealer?.dealerId) {
  //       // console.log('No dealer ID available, skipping saved order check');
  //       return;
  //     }
  //     try {
  //       // console.log('Checking for saved in-store orders for dealer:', dealer.dealerId);
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_REST_BASE_URL}/Orders/withdealer?search=${dealer.dealerId}&sortingCol=dateTimeCreated&sortType=desc`
  //       );
  //       // console.log('Saved orders response:', response.data);
  //       const orders = response.data.data;
  //       // console.log('Orders array:', orders);
  //       if (orders && orders.length > 0) {
  //         // Find the first order that matches both conditions
  //         const matchingOrder = orders.find((order: { status: number; offsite: boolean }) => 
  //           order.status === 1 && order.offsite === false
  //         );

  //         if (matchingOrder) {
  //           // console.log('Valid saved order found:', matchingOrder);
  //           setSavedOrder(matchingOrder);
  //           setIsSavedOrderDialogOpen(true);
  //         } else {
  //           // Only set cart to undefined if there's no existing cart
  //           if (!cart) {
  //             setCart?.({
  //               shippingFee: settings?.shippingFee,
  //               coopEligible: settings?.coopEligible,
  //               products: []
  //             });
  //           }
  //           // console.log('No matching saved orders found with status=1 and offsite=false');
  //           // console.log('Cart after setting shipping fee:', settings?.shippingFee);
  //         }
  //       } else {
  //         // console.log('No saved orders found');
  //       }
  //     } catch (error) {
  //       // console.error('Error checking saved order:', error);
  //       if (axios.isAxiosError(error)) {
  //         console.error('Error details:', {
  //           status: error.response?.status,
  //           data: error.response?.data,
  //           message: error.message
  //         });
  //       }
  //     }
  //   };
  //   checkSavedOrder();
  // }, [dealer?.dealerId]);

  const handleContinueSaved = async () => {
    if (!savedOrder?.orderId) {
      // console.log('No saved order ID available');
      return;
    }
    if (settings?.shippingFee == null) {
      // Wait for settings to load, or show a loading spinner
      alert("Settings not loaded yet. Please try again in a moment.");
      return;
    }
    try {
      // console.log('Fetching full order details for order:', savedOrder.orderId);
      const response = await axios.get(
        `${process.env.REACT_APP_REST_BASE_URL}/Orders/getorderfull/${savedOrder.orderId}`
      );
      // console.log('Full order details received:', response.data);
      setCart?.({
        ...response.data,
        shippingFee: settings.shippingFee,
        coopEligible: settings.coopEligible,
        // coopAmount: settings.couponAmount,
      });
      // console.log('Cart after setting shipping fee:', settings.shippingFee);
      setIsSavedOrderDialogOpen(false);
    } catch (error) {
      console.error('Error loading saved order:', error);
      if (axios.isAxiosError(error)) {
        console.error('Error details:', {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message
        });
      }
    }
  };

  const handleNewOrder = async () => {
    if (!savedOrder?.orderId) {
      // console.log('No saved order ID available');
      return;
    }
    setIsSavedOrderDialogOpen(false);
    setCart?.({
      shippingFee: settings?.shippingFee,
      coopEligible: settings?.coopEligible,
      products: []
    });
  };

  return (
    <AppContextProvider>
      {/* <S.HomePage> */}
        {/* <S.HomePageHeaderContainer>
          <HomePageHeader />
        </S.HomePageHeaderContainer> */}
        {/* <S.ProductCatalogContainer> */}
        <Cart />
        {/* <ProductCatalog /> */}
        {/* </S.ProductCatalogContainer> */}
      {/* </S.HomePage> */}
      <SavedOrderDialog
        open={isSavedOrderDialogOpen}
        onClose={() => setIsSavedOrderDialogOpen(false)}
        onContinueSaved={handleContinueSaved}
        onNewOrder={handleNewOrder}
      >
        {/* Custom message for in-store */}
      </SavedOrderDialog>
    </AppContextProvider>
  );
};

export default Home;
